var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.column === "lostBenefit" && _vm.currency !== ""
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(parseFloat(_vm.currencyContent.lostBenefit).toFixed(2)) +
                  " " +
                  _vm._s(_vm.currency)
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "percentageOfSummary"
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.asPercentage(
                    _vm.currencyContent.percentageGrossSummaryAll
                  )
                )
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "percentageOfCount"
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(_vm.asPercentage(_vm.currencyContent.percentageCountAll))
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "lostBenefitPercentage" && _vm.currency !== ""
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(
                  parseFloat(
                    (_vm.currencyContent.lostBenefit /
                      _vm.currencyContent.grossSummary) *
                      100
                  ).toFixed(1)
                ) + " %"
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "count"
        ? [_c("h3", [_vm._v(" " + _vm._s(_vm.currencyContent.count) + " ")])]
        : _vm._e(),
      _vm.column === "averageTicketPrice" && _vm.currency !== ""
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(
                  parseFloat(
                    _vm.currencyContent.grossSummary / _vm.currencyContent.count
                  ).toFixed(2)
                ) +
                  " " +
                  _vm._s(_vm.currency)
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "fareBase" && _vm.currency !== ""
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(parseFloat(_vm.currencyContent.fareBase).toFixed(2)) +
                  " " +
                  _vm._s(_vm.currency)
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "discount" && _vm.currency !== ""
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(parseFloat(_vm.currencyContent.discount).toFixed(2)) +
                  " " +
                  _vm._s(_vm.currency)
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "airportCharges" && _vm.currency !== ""
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(
                  parseFloat(_vm.currencyContent.airportCharges).toFixed(2)
                ) +
                  " " +
                  _vm._s(_vm.currency)
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "grossSummary" && _vm.currency !== ""
        ? [
            _c("h3", [
              _c("span", { staticClass: "datatable-total-amount" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      parseFloat(_vm.currencyContent.grossSummary).toFixed(2)
                    ) +
                    " " +
                    _vm._s(_vm.currency) +
                    " "
                )
              ])
            ])
          ]
        : _vm._e(),
      _vm.column === "grossSummaryWithDiscount" && _vm.currency !== ""
        ? [
            _c("h3", [
              _c("span", { staticClass: "datatable-total-amount" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      parseFloat(
                        _vm.currencyContent.grossSummaryWithDiscount
                      ).toFixed(2)
                    ) +
                    " " +
                    _vm._s(_vm.currency) +
                    " "
                )
              ])
            ])
          ]
        : _vm._e(),
      _vm.column === "netSummary" && _vm.currency !== ""
        ? [
            _c("h3", [
              _c("span", { staticClass: "datatable-net-amount" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      parseFloat(_vm.currencyContent.netSummary).toFixed(2)
                    ) +
                    " " +
                    _vm._s(_vm.currency) +
                    " "
                )
              ])
            ])
          ]
        : _vm._e(),
      _vm.column === "percentageOfOrganizationalUnitCount"
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.asPercentage(
                    _vm.currencyContent.percentageCountOrganizationUnit
                  )
                )
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "percentageOfDomesticForeignCount"
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.asPercentage(
                    _vm.currencyContent.percentageCountDomesticForeign
                  )
                )
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "percentageOfOrganizationalUnitAmount"
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.asPercentage(
                    _vm.currencyContent.percentageGrossSummaryOrganizationUnit
                  )
                )
              )
            ])
          ]
        : _vm._e(),
      _vm.column === "percentageOfDomesticForeignAmount"
        ? [
            _c("h3", [
              _vm._v(
                _vm._s(
                  _vm.asPercentage(
                    _vm.currencyContent.percentageGrossSummaryDomesticForeign
                  )
                )
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }